// ProtectedRoute.js

import { Navigate } from "react-router-dom";
import React from "react";
import { useSelector } from "react-redux";
const ProtectedRoutes = ({ Component, requiredRoles }) => {
  const user = useSelector((state) => state?.Auth?.user?.user);
  const isTeamOwner = user?.isTeamOwner;
  const isTeamAdmin = user?.userTeam?.isteamAdmin ?? false;

  console.log("HERE", isTeamAdmin, user)

  let tipReciever = user?.userType;
console.log("user--->",user)
  let userRole = "admin";
  if(user?.userType=== "payer"){
    console.log("isTeamAdmin==>",user?.userType)
    userRole = "tipGiver";
  }else if(user?.isTeamAdmin){
    userRole = "teamAdmin";
  }else if (user?.accountType === "business") {
    userRole = "businessUser";
  } else if(user?.accountType === "individual") {
    userRole = "individualRole";
  }else if(user?.accountType === "teamMember") {
    userRole = "teamMember";
  }else{
  
   if (isTeamOwner) {
      userRole = "teamOwner";
    } else if (tipReciever === "payee") {
      userRole = "tipReciever";
    }
  }

  if (isTeamAdmin) {
    console.log("HERE12", isTeamAdmin)
    userRole = "teamAdmin";
  }

  const isAllowed = requiredRoles.includes(userRole);
  return <>{isAllowed ? <Component /> : <Navigate to='/Home' />}</>;
};

export default ProtectedRoutes;
